import apiSlice from 'renderer/shared/state/apiSlice';
import {
  AssignLicenseRequest,
  AssignLicenseResponse,
  CreateProductRequest,
  CreateProductResponse,
  DeleteProductRequest,
  DeleteProductResponse,
  DeletedProductSchema,
  EditProductRequest,
  EditProductResponse,
  GetLicenseDetailsRequest,
  GetLicenseDetailsResponse,
  GetProductByPriceIdRequest,
  GetProductByPriceIdResponse,
  GetProductDetailsRequest,
  GetProductDetailsResponse,
  LicenseDetailsSchema,
  ListProductsRequest,
  ListProductsResponse,
  ListProductsResponseSchema,
  ProductDetailsSchema,
  ProductFormResponseSchema,
} from '../schemas/products.schemas';

const extendedApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    listProducts: builder.query<ListProductsResponse, ListProductsRequest>({
      query: ({ includeHidden }) =>
        `/product/?includeHidden=${includeHidden ?? false}`,
      providesTags: ['Product'],
      extraOptions: {
        responseSchema: ListProductsResponseSchema,
      },
    }),
    getProductDetails: builder.query<
      GetProductDetailsResponse,
      GetProductDetailsRequest
    >({
      query: (productId) => `/product/${productId}`,
      providesTags: ['Product'],
      extraOptions: {
        responseSchema: ProductDetailsSchema,
      },
    }),
    getProductByPriceId: builder.query<
      GetProductByPriceIdResponse,
      GetProductByPriceIdRequest
    >({
      query: (priceId) => `/product/priceId/${priceId}`,
      providesTags: ['Product'],
      extraOptions: {
        responseSchema: ProductDetailsSchema,
      },
    }),
    getLicenseDetails: builder.query<
      GetLicenseDetailsResponse,
      GetLicenseDetailsRequest
    >({
      query: () => '/product/license/details',
      // providesTags: ['Product'],
      extraOptions: {
        responseSchema: LicenseDetailsSchema,
      },
    }),
    assignLicense: builder.mutation<
      AssignLicenseResponse,
      AssignLicenseRequest
    >({
      query: (body) => ({
        url: '/product/license/assign',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['User'],
    }),
    createProduct: builder.mutation<
      CreateProductResponse,
      CreateProductRequest
    >({
      query: (product) => ({
        url: '/product',
        method: 'POST',
        body: product,
      }),
      invalidatesTags: ['Product'],
      extraOptions: {
        responseSchema: ProductFormResponseSchema,
      },
    }),
    editProduct: builder.mutation<EditProductResponse, EditProductRequest>({
      query: ({ body, id }) => ({
        url: `/product/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Product'],
      extraOptions: {
        responseSchema: ProductFormResponseSchema,
      },
    }),
    deleteProduct: builder.mutation<
      DeleteProductResponse,
      DeleteProductRequest
    >({
      query: (id) => ({
        url: `/product/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Product'],
      extraOptions: {
        responseSchema: DeletedProductSchema,
      },
    }),
  }),
});

export const {
  useListProductsQuery,
  useGetProductDetailsQuery,
  useLazyGetProductDetailsQuery,
  useGetProductByPriceIdQuery,
  useGetLicenseDetailsQuery,
  useAssignLicenseMutation,
  useCreateProductMutation,
  useEditProductMutation,
  useDeleteProductMutation,
} = extendedApi;
